import React, { useState } from 'react';

export default function Accordion(props) {
  const {
    data = [
      { title: "Lorem Ipsum is simply", content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book." },
      { title: "Lorem Ipsum is simply", content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book." },
      { title: "Lorem Ipsum is simply", content: "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book." },
    ],
    expandMode = 'single',
    defaultExpanded = [-1]
  } = props;

  const [expandedItems, setExpandedItems] = useState(defaultExpanded);

  const toggleItem = (index) => {
    if (expandMode === 'single') {
      setExpandedItems(expandedItems[0] === index ? [] : [index]);
    } else {
      setExpandedItems((prev) =>
        prev.includes(index)
          ? prev.filter((i) => i !== index)
          : [...prev, index]
      );
    }
  };

  return (
    <div className="tw:m-4 tw:border tw:border-[#dedede] tw:border-b-0 tw:rounded-[4px]">
      {data.map((item, index) => (
        <div key={index} className="tw:border-b tw:border-[#dedede] tw:[&:last-of-type]:rounded-b-[4px]">
          <button
            onClick={() => toggleItem(index)}
            className="tw:w-full tw:text-left tw:px-[16px] tw:py-[13px] tw:min-h-[40px] tw:transition tw:flex tw:justify-between tw:items-center tw:cursor-pointer"
          >
            <span className="tw:text-[#3a3a3a] tw:text-[14px] tw:font-normal tw:leading-[25px]">{item.title}</span>
            <span className={`tw:transform tw:transition-transform ${expandedItems.includes(index) ? 'tw:tw:rotate-180' : 'tw:rotate-0'}`}>
              <svg xmlns="http://www.w3.org/2000/svg" width="12" height="7" viewBox="0 0 12 7" fill="none">
                <path d="M10.2875 6.29344L6.4075 2.41344L2.5275 6.29344C2.1375 6.68344 1.5075 6.68344 1.1175 6.29344C0.727499 5.90344 0.727499 5.27344 1.1175 4.88344L5.7075 0.293438C6.0975 -0.0965619 6.7275 -0.0965619 7.1175 0.293438L11.7075 4.88344C12.0975 5.27344 12.0975 5.90344 11.7075 6.29344C11.3175 6.67344 10.6775 6.68344 10.2875 6.29344Z" fill="#808080" />
              </svg>
            </span>
          </button>
          {expandedItems.includes(index) && (
            <div className="tw:px-[16px] tw:py-[13px] tw:text-[#212529] tw:text-[13px] tw:font-normal tw:leading-[20px]">
              {item.content}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};
